'use client';

import AdminWarning from '@/src/components/AdminWarning';
import RouteLoadingIndicator from '@/src/components/RouteLoadingIndicator';

interface BorderlessLayoutProps {
  children: React.ReactNode;
}

export const BorderlessLayout = ({ children }: BorderlessLayoutProps) => {
  return (
    <div className="page-container">
      <AdminWarning />
      <RouteLoadingIndicator />
      {children}
    </div>
  );
};

export default BorderlessLayout;
